module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.showModalAdjuntar) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdjuntar()
      }
    }
  }), _c('upload-image', {
    attrs: {
      "name": "reunion_capacitacion",
      "folder": "reunion"
    },
    on: {
      "save": _vm.guardarAdjunto,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjuntar archivo")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta el archivo deseado")]), _c('i', {
    staticClass: "fa fa-file-text",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  })])], 1) : _vm._e()]), _c('div', {
    staticClass: "title pt-5"
  }, [_c('span', {
    staticClass: "fw-400"
  }, [_vm._v(_vm._s(_vm.idReunion ? 'Editar' : 'Nuevo'))])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "display-flex mb-5"
  }, [_c('div', {
    staticClass: "volver display-flex flex-1"
  }, [_c('button', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.volver()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _c('span', [_vm._v("Volver")])])]), (_vm.form.estado !== 2) ? _c('button', {
    staticClass: "button is-small mr-5",
    on: {
      "click": function($event) {
        return _vm.guardar()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _c('span', [_vm._v("Guardar")])]) : _vm._e(), (_vm.form.estado === 0) ? _c('button', {
    staticClass: "button is-small is-primary mr-5",
    on: {
      "click": function($event) {
        return _vm.cambiarEstado(1)
      }
    }
  }, [_c('span', [_vm._v("Terminar")])]) : _vm._e(), (_vm.form.estado === 0) ? _c('button', {
    staticClass: "button is-small is-danger mr-5",
    on: {
      "click": function($event) {
        return _vm.cambiarEstado(2)
      }
    }
  }, [_c('span', [_vm._v("No se realizó")])]) : _vm._e(), (_vm.form.estado === 0) ? _c('button', {
    staticClass: "button is-small is-success",
    on: {
      "click": function($event) {
        return _vm.notificar()
      }
    }
  }, [_c('span', [_vm._v("Notificar")])]) : _vm._e()]), _c('div', {
    staticClass: "body pt-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tipo),
      expression: "form.tipo"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "reunion",
      "value": "reunion",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "checked": _vm._q(_vm.form.tipo, "reunion")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "tipo", "reunion")
      }
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Reunión")])]), _c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tipo),
      expression: "form.tipo"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "reunion",
      "value": "capacitacion",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "checked": _vm._q(_vm.form.tipo, "capacitacion")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "tipo", "capacitacion")
      }
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Capacitación")])])])]), _c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Título")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.titulo),
      expression: "form.titulo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "titulo", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "control margin-bottom-10 mt-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripción")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.descripcion),
      expression: "form.descripcion"
    }],
    staticClass: "textarea w-300",
    staticStyle: {
      "field-sizing": "content !important"
    },
    attrs: {
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "descripcion", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.modalidad),
      expression: "form.modalidad"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "modalidad",
      "value": "presencial",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "checked": _vm._q(_vm.form.modalidad, "presencial")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.form, "modalidad", "presencial")
      }, _vm.handlerModalidad]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Presencial")])]), _c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.modalidad),
      expression: "form.modalidad"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "modalidad",
      "value": "virtual",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "checked": _vm._q(_vm.form.modalidad, "virtual")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.form, "modalidad", "virtual")
      }, _vm.handlerModalidad]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Virtual")])])])]), _c('div', {
    staticClass: "display-flex"
  }, [(_vm.form.modalidad === 'presencial') ? _c('div', {
    staticClass: "control margin-bottom-10 m-2"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Sala")]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.idSala),
      expression: "form.idSala"
    }],
    attrs: {
      "disabled": _vm.isLoadingReunion || _vm.isLoadingSalas || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "idSala", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.salas), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))])
  }), 0)])]) : _vm._e(), (_vm.form.modalidad === 'virtual') ? _c('div', {
    staticClass: "control margin-bottom-10 flex-1 mt-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.link),
      expression: "form.link"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "link", $event.target.value)
      }
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "display-flex mt-5"
  }, [_c('div', {
    staticClass: "control mr-5"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Fecha")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.fecha),
      expression: "form.fecha"
    }],
    staticClass: "input w-100",
    attrs: {
      "type": "date",
      "step": "1",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.fecha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "fecha", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control mr-5"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Desde")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.horaDesde),
      expression: "form.horaDesde"
    }],
    staticClass: "input w-80",
    attrs: {
      "type": "time",
      "step": "60",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.horaDesde)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "horaDesde", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Hasta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.horaHasta),
      expression: "form.horaHasta"
    }],
    staticClass: "input w-80",
    attrs: {
      "type": "time",
      "step": "60",
      "disabled": _vm.isLoadingReunion || _vm.esReunionTerminada || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.horaHasta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "horaHasta", $event.target.value)
      }
    }
  })])]), (_vm.mostrarAsistentes) ? _c('div', {
    staticClass: "display-flex fdr space-evenly flex-wrap pt-10"
  }, [_c('asistentes-lista', {
    ref: "asistenteRef",
    attrs: {
      "codigoCreador": _vm.form.codigoCreador,
      "esReunionTerminada": _vm.esReunionTerminada,
      "esReunionAnulada": _vm.esReunionAnulada
    },
    on: {
      "save": function($event) {
        return _vm.saveAsistente()
      }
    }
  })], 1) : _vm._e(), (_vm.esReunionTerminada || _vm.esReunionAnulada) ? [_c('div', {
    staticClass: "field mt-5 text-align-left"
  }, [_c('strong', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Minuta")]), _c('div', {
    staticClass: "control margin-top-10 flex-1"
  }, [_c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.minutaOpcion),
      expression: "form.minutaOpcion"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "minuta",
      "value": "texto",
      "disabled": _vm.isLoadingReunion || _vm.esReunionAnulada
    },
    domProps: {
      "checked": _vm._q(_vm.form.minutaOpcion, "texto")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.form, "minutaOpcion", "texto")
      }, _vm.handlerMinuta]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Texto")])]), _c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.minutaOpcion),
      expression: "form.minutaOpcion"
    }],
    staticClass: "radio",
    attrs: {
      "type": "radio",
      "name": "minuta",
      "value": "link",
      "disabled": _vm.isLoadingReunion || _vm.esReunionAnulada
    },
    domProps: {
      "checked": _vm._q(_vm.form.minutaOpcion, "link")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.form, "minutaOpcion", "link")
      }, _vm.handlerMinuta]
    }
  }), _c('span', {
    staticClass: "margin-left-5"
  }, [_vm._v("Archivo adjunto")])])])]), (_vm.form.minutaOpcion === 'texto') ? _c('div', {
    staticClass: "control margin-bottom-10 mt-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.minutaDescripcion),
      expression: "form.minutaDescripcion"
    }],
    staticClass: "textarea w-300",
    staticStyle: {
      "field-sizing": "content !important"
    },
    attrs: {
      "disabled": _vm.isLoadingReunion || _vm.esReunionAnulada
    },
    domProps: {
      "value": (_vm.form.minutaDescripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "minutaDescripcion", $event.target.value)
      }
    }
  })]) : _vm._e(), (_vm.form.minutaOpcion === 'link') ? _c('div', {
    staticClass: "control margin-bottom-10 flex-1 mt-10"
  }, [(_vm.form.minutaLink) ? _c('div', {
    staticClass: "mb-5 mt-5 adjunto"
  }, [_c('a', {
    staticClass: "button is-small",
    attrs: {
      "href": _vm.form.minutaLink,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paperclip is-small"
  })]), _c('span', [_vm._v("Ver adjunto")])]), _c('span', {
    staticClass: "icon color-red margin-left-5 cursor-pointer",
    style: ({
      'pointer-events': _vm.esReunionAnulada ? 'none' : 'auto'
    }),
    attrs: {
      "tittle": "Borrar adjunto"
    },
    on: {
      "click": function($event) {
        return _vm.borrarAdjunto()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])]) : _c('button', {
    staticClass: "button is-small is-primary",
    attrs: {
      "disabled": _vm.esReunionAnulada
    },
    on: {
      "click": _vm.abrirModalAdjuntar
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload is-small"
  })]), _c('span', [_vm._v("Adjuntar")])])]) : _vm._e()] : _vm._e()], 2)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-434f8435","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Reuniones_Editar.vue
// module id = 800
// module chunks = 0